import accordbank from './assets/accordbank.webp';
import bankcreditdnipro from './assets/bankcreditdnipro.webp';
import creditagricole from './assets/creditagricole.webp';
import globus from './assets/globusplus.webp';
import izibank from './assets/izibank.webp';
import kredobank from './assets/kredobank.webp';
import monobank from './assets/monobank.webp';
import mtbbank from './assets/mtbbank.webp';
import obank from './assets/obank.webp';
import otpbank from './assets/otpbank.webp';
import privat24 from './assets/privat24.webp';
import pumb from './assets/pumb.png';
import raiffiesenbak from './assets/raiffiesenbank.webp';
import sensebank from './assets/sensebank.webp';
import ugb from './assets/ugb.webp';
import ukrsibbank from './assets/ukrsibbank.webp';
import unexbank from './assets/unexbank.webp';
import vstbank from './assets/vstbank.webp';
import abank from './assets/abank.webp';
import alliancebank from './assets/alliancebank.webp';
import pravexbank from './assets/pravexbank.webp';
import pivdenny from './assets/pivdenny.webp';
import bank34 from './assets/bank34.webp';

export default [
  {
    logo: monobank,
    label: 'Monobank',
    code: 'monobank',
    order: { ios: 1, android: 1 },
    deeplink: {
      android: 'com.ftband.mono',
      ios: 'mono',
    },
  },
  {
    logo: privat24,
    label: 'Приват24',
    code: 'privat24',
    order: { ios: 2, android: 2 },
    deeplink: {
      android: 'ua.privatbank.ap24',
      ios: 'privat24',
    },
  },
  {
    logo: abank,
    label: 'А-Банк',
    code: 'abank',
    order: { ios: 3, android: 3 },
    deeplink: {
      android: 'ua.com.abank',
      ios: 'abank24',
    },
  },
  {
    logo: pumb,
    label: 'ПУМБ',
    code: 'pumb',
    order: { ios: 999, android: 21 },
    deeplink: {
      android: 'com.fuib.android.spot.online',
      ios: '',
    },
  },
  {
    logo: sensebank,
    label: 'Sense Bank',
    code: 'sensebank',
    order: { ios: 4, android: 4 },
    deeplink: {
      android: 'ua.alfabank.mobile.android',
      ios: qr => qr.replace('https://bank.gov.ua/qr/', 'https://superapp.sensebank.com.ua/mob/qr/'),
    },
  },
  {
    logo: ukrsibbank,
    label: 'Укрсіббанк',
    code: 'ukrsibbank',
    order: { ios: 12, android: 20 },
    deeplink: {
      android: 'com.ukrsibbank.uso.android',
      ios: qr =>
        qr.replace(
          'https://bank.gov.ua/qr/',
          'https://online.ukrsibbank.com/ibank/new-app/qr?url=https://bank.gov.ua/qr/'
        ),
    },
  },
  {
    logo: raiffiesenbak,
    label: 'Райффайзен Банк',
    code: 'raiffiesenbank',
    order: { ios: 5, android: 5 },
    deeplink: {
      android: 'ua.raiffeisen.myraif',
      ios: qr =>
        qr.replace('https://bank.gov.ua/qr/', 'https://my-raif.apps.raiffeisen.ua/qr?payload='),
    },
  },
  {
    logo: ugb,
    label: 'Ukrgasbank',
    code: 'ukrgasbank',
    order: { ios: 999, android: 19 },
    deeplink: {
      android: 'com.ugb.app',
      ios: '',
    },
  },
  {
    logo: izibank,
    label: 'izibank',
    code: 'izibank',
    order: { ios: 999, android: 9 },
    deeplink: {
      android: 'ua.izibank.app',
      ios: '',
    },
  },
  {
    logo: mtbbank,
    label: 'МТБ Банк',
    code: 'mtbbank',
    order: { ios: 8, android: 8 },
    deeplink: {
      android: 'com.ua.mtb.bank',
      ios: qr => qr.replace('https://bank.gov.ua/qr/', 'https://web.a115.mtb.ua/qr-nbu/'),
    },
  },
  {
    logo: kredobank,
    label: 'KredoBank',
    code: 'kredobank',
    order: { ios: 999, android: 13 },
    deeplink: {
      android: 'ua.android.kredobank.prod',
      ios: '',
    },
  },
  {
    logo: creditagricole,
    label: 'Креді Агріколь Банк',
    code: 'creditagricole',
    order: { ios: 13, android: 14 },
    deeplink: {
      android: 'ua.creditagricole.mobile.app',
      ios: qr =>
        qr.replace('https://bank.gov.ua/qr/', 'https://caplusapp.credit-agricole.ua/fr/pay/'),
    },
  },
  {
    logo: otpbank,
    label: 'ОТП БАНК',
    code: 'otpbank',
    order: { ios: 7, android: 7 },
    deeplink: {
      android: 'ua.otpbank.android',
      ios: qr => qr.replace('https://bank.gov.ua/qr/', 'https://pay.dev.obudev.in/qr/'),
    },
  },
  {
    logo: accordbank,
    label: 'Аккордбанк',
    code: 'accordbank',
    order: { ios: 10, android: 11 },
    deeplink: {
      android: 'online.kapowai.accordbank',
      ios: qr => qr.replace('https://bank.gov.ua/qr/', 'https://online.accordbank.com.ua/nbu/qr/'),
    },
  },
  {
    logo: bankcreditdnipro,
    label: 'Банк Кредит Дніпро',
    code: 'bankcreditdnipro',
    order: { ios: 9, android: 10 },
    deeplink: {
      android: 'com.creditdnepr.mb',
      ios: qr => qr.replace('https://bank.gov.ua/qr/', 'https://creditdnepr.com.ua/qr_code/?'),
    },
  },
  {
    logo: globus,
    label: 'Глобус Банк',
    code: 'globus',
    order: { ios: 999, android: 15 },
    deeplink: {
      android: 'com.t18.bone.personal.globus',
      ios: '',
    },
  },
  {
    logo: obank,
    label: 'Ідея Банк',
    code: 'ideabank',
    order: { ios: 999, android: 16 },
    deeplink: {
      android: 'ua.ideabank.obank',
      ios: '',
    },
  },
  {
    logo: unexbank,
    label: 'Unex Bank',
    code: 'unexbank',
    order: { ios: 999, android: 17 },
    deeplink: {
      android: 'online.kapowai.unexbank',
      ios: '',
    },
  },
  {
    logo: vstbank,
    label: 'VST bank',
    code: 'vstbank',
    order: { ios: 999, android: 18 },
    deeplink: {
      android: 'com.vostok.bv',
      ios: '',
    },
  },
  {
    logo: alliancebank,
    label: 'Alliance Bank',
    code: 'alliancebank',
    order: { ios: 6, android: 6 },
    deeplink: {
      android: 'ua.monvel.bankalliance',
      ios: qr => qr.replace('https://bank.gov.ua/qr/', 'https://alb.ua/qr/'),
    },
  },
  {
    logo: pravexbank,
    label: 'ПРАВЕКС БАНК',
    code: 'pravexbank',
    order: { ios: 14, android: 999 },
    deeplink: {
      android: '',
      ios: qr => qr.replace('https://bank.gov.ua/qr/', 'https://online.pravex.ua/mobileapp/qr/'),
    },
  },
  {
    logo: pivdenny,
    label: 'Банк Південний',
    code: 'pivdenny',
    order: { ios: 11, android: 12 },
    deeplink: {
      android: 'com.bank.pivdenny',
      ios: '',
    },
  },
  {
    logo: bank34,
    label: 'Банк 3/4',
    code: 'bank34',
    order: { ios: 999, android: 22 },
    deeplink: {
      android: 'online.kapowai.bank34online',
      ios: '',
    },
  },
];
